/**
 * ruts-vh-card-swatch-position.js
 *
 * Responsabilidad única: mover el nodo .sk-cs (swatches inyectados por
 * Variant Hero dentro de PRODUCT-PRICE) para que quede inmediatamente antes
 * del bloque real del título, dentro de la misma .product-card.
 *
 * No gestiona clics, hover, variantes, imágenes, precios, enlaces, títulos
 * ni el control +N. No usa preventDefault/stopPropagation. No clona nodos:
 * siempre mueve el nodo original con insertBefore, así que Variant Hero
 * conserva sus propios listeners intactos.
 *
 * Incluido solo en index, collection y search (ver layout/theme.liquid).
 * Observer acotado a <main>, nunca a document.body.
 */
(function () {
  'use strict';

  var main = document.querySelector('main');
  if (!main) return;

  function findTitleBlock(card) {
    var content = card.querySelector('.product-card__content');
    if (!content) return null;

    var titleTextEl = content.querySelector('[class*="__product_title"], [class*="__ptitle"]');
    if (!titleTextEl) return null;

    var node = titleTextEl;
    while (node && node.parentElement !== content) {
      node = node.parentElement;
    }
    if (!node || node.parentElement !== content) return null;

    return node;
  }

  function moveSwatches(card) {
    var content = card.querySelector('.product-card__content');
    if (!content) return;

    var sk = content.querySelector('.sk-cs');
    if (!sk) return;

    var titleBlock = findTitleBlock(card);
    if (!titleBlock) return;

    // Ya está inmediatamente antes del título: nada que hacer, evita bucles.
    if (sk.nextElementSibling === titleBlock) return;

    content.insertBefore(sk, titleBlock);
  }

  function processCard(card) {
    if (!card || !card.classList || !card.classList.contains('product-card')) return;
    if (card.querySelector('.sk-cs')) {
      moveSwatches(card);
    }
  }

  function handleAddedNode(node) {
    if (!node || node.nodeType !== 1) return;

    // Caso 1: se añadió una tarjeta nueva (o un contenedor con tarjetas
    // dentro) tras un filtro, orden, carrusel o render posterior.
    if (node.matches && node.matches('.product-card')) {
      processCard(node);
    } else if (node.querySelectorAll) {
      var cards = node.querySelectorAll('.product-card');
      for (var i = 0; i < cards.length; i++) {
        processCard(cards[i]);
      }
    }

    // Caso 2: Variant Hero inyectó .sk-cs dentro de una tarjeta que ya
    // existía en el DOM (p. ej. al iniciar tras hover).
    var ownerCard = node.closest ? node.closest('.product-card') : null;
    if (ownerCard) {
      processCard(ownerCard);
    }
  }

  // Barrido inicial por si alguna tarjeta ya tiene swatches al cargar.
  var initialCards = main.querySelectorAll('.product-card');
  for (var i = 0; i < initialCards.length; i++) {
    processCard(initialCards[i]);
  }

  var observer = new MutationObserver(function (mutations) {
    for (var m = 0; m < mutations.length; m++) {
      var addedNodes = mutations[m].addedNodes;
      for (var n = 0; n < addedNodes.length; n++) {
        handleAddedNode(addedNodes[n]);
      }
    }
  });

  observer.observe(main, { childList: true, subtree: true });
})();
